export default __webpack_public_path__ + "static/media/team2.55d2ee75.jpg";